import { render, staticRenderFns } from "./ComplaintsTableActions.vue?vue&type=template&id=014d033c&scoped=true"
import script from "./ComplaintsTableActions.vue?vue&type=script&lang=js"
export * from "./ComplaintsTableActions.vue?vue&type=script&lang=js"
import style0 from "./ComplaintsTableActions.vue?vue&type=style&index=0&id=014d033c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "014d033c",
  null
  
)

export default component.exports